import { PartialNullable } from "../../Extensions";
import { StringHelper } from "../../Helpers/StringHelper";
import { $$, IJNativeEvent } from "../../JNative";
import { Property } from "../../RadObject";
import { JsxFragment } from "../JsxFragment";
import { PageManager } from "../PageManager";
import { ContainerControl, ContainerControlPropertyValues, IContainerControl } from "./ContainerControl";
import { NAMESPACE } from "./_Namespace";

import "./WindowHeader.scss";

export type WindowHeaderPropertyValues =
    ContainerControlPropertyValues
    & {
    };

export type WindowHeaderProperties = {
    [name in keyof WindowHeaderPropertyValues]: Property<WindowHeaderPropertyValues[name]>
};

export interface IWindowHeader extends IContainerControl, WindowHeaderProperties
{
}

export class WindowHeader extends ContainerControl implements IWindowHeader
{
    public static override classNamespace = NAMESPACE + "WindowHeader";
    public static override className = "WindowHeader";

    // #region Constructor

    constructor(propertyValues?: PartialNullable<WindowHeaderPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-window-header ui fixed inverted main menu");
    }

    // #endregion

    // #region Protected Methods

    protected _addScrollbarPadding()
    {
        this.$$element.get()?.css({
            paddingRight: (PageManager.instance?.scrollBarDimensions.get()?.width ?? 0) + "px"
        });
    }
    protected _removeScrollbarPadding()
    {
        this.$$element.get()?.css({
            paddingRight: StringHelper.empty
        });
    }

    // #endregion

    // #region Overrides

    protected override _bindEvents()
    {
        super._bindEvents();
        $$(document).on("SeriouslyRAD.Application:Ready", { self: this }, this.onApplicationReady);
    }
    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <header>
                <div ref={this._containerElementRef} class="ui container fluid">
                    {children ?? this._createChildrenHtml()}
                </div>
            </header>
        );
    }

    // #endregion

    // #region Event Handlers

    protected onApplicationReady(evt: IJNativeEvent)
    {
        const
            self = evt.data.self as this;

        self._addScrollbarPadding();
    }

    // #endregion
}

